import { useEffect } from 'react';
import { useAuthentication } from '@johnlewispartnership/wtr-website-authentication/dist/context';
import { useAnalytics } from '@johnlewispartnership/wtr-website-analytics';
import customerOrderService from 'services/customer-order';
import membershipService from 'services/membership';

export const useUserEventTracking = () => {
  const { state } = useAuthentication();
  const { trackEvent } = useAnalytics();

  useEffect(() => {
    if (!state.initialised) {
      return;
    }

    if (!state.isLoggedIn) {
      trackEvent({
        event: '',
        user: {
          customer_id: '-1',
          login_status: false,
          customer_type: undefined,
          days_since_last_shop: undefined,
          mywaitrose_customer: 'N',
        },
      });
      return;
    }

    const authHeader = state.token?.authHeader;
    const customerId = state?.customerId;

    if (!authHeader) {
      return;
    }

    Promise.allSettled([
      customerOrderService.getCustomerOrdersStats(authHeader),
      membershipService.getMembershipNumber(authHeader),
    ]).then(([ordersResult, membershipResult]) => {
      const ordersData = ordersResult.status === 'fulfilled' ? ordersResult.value.data : undefined;
      const membershipFetched = membershipResult.status === 'fulfilled';
      const membershipNumber = membershipFetched ? membershipResult.value : undefined;

      const hasCompletedOrder = ordersData?.customerHasACompletedOrder;

      trackEvent({
        event: '',
        user: {
          customer_id: customerId,
          login_status: true,
          customer_type:
            hasCompletedOrder !== undefined ? (hasCompletedOrder ? 'Existing' : 'New') : undefined,
          days_since_last_shop: ordersData?.daysSinceLastCompletedOrder,
          mywaitrose_customer: membershipFetched ? (membershipNumber ? 'Y' : 'N') : undefined,
        },
      });
    });
  }, [state?.customerId, state.initialised, state.isLoggedIn, state.token, trackEvent]);
};
